// extracted by mini-css-extract-plugin
module.exports = {"StockOptionsPage":"options_StockOptionsPage__4J_k_"};